import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/cagr-with-contributions-calculator',
  component: () => import('../../routes/CagrWithContributionsCalculator.svelte'),
  card: {
    id: 'cagr-with-contributions-calculator',
    title: 'CAGR with Contributions',
    description: 'Calculate compound annual growth rate with both initial investment and monthly contributions.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/cagr-with-contributions-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'CAGR with Contributions Calculator – Compound Growth with Monthly Investments',
    description: 'Calculate compound annual growth rate (CAGR) with both initial investment and monthly contributions. See how consistent contributions amplify your investment growth over time.',
  },
};

export default meta;